export default __webpack_public_path__ + "i18n/translations/translation-en.b141293b.json";